import { render, staticRenderFns } from "./Contrato.vue?vue&type=template&id=2c3ef146&scoped=true&lang=pug&"
import script from "./Contrato.vue?vue&type=script&lang=js&"
export * from "./Contrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3ef146",
  null
  
)

export default component.exports